import { useQuery } from '@apollo/client'
import DataCollectionInfo from 'components/atoms/DataCollectionInfo'
import { PharmacyForm, ProfileForm } from 'components/me/profile'
import styled from 'styled-components'
import { colors } from 'theme'
import { type MySubscriptionQuery } from 'types/graphql'
import { checkOwner } from 'utils/subscription'

import { SUBSCRIPTION } from '@/graphql/queries/user'

const Profile = () => {
  const userQuery = useQuery<MySubscriptionQuery>(SUBSCRIPTION)

  if (userQuery.loading || !userQuery.data?.me) {
    return null
  }

  const { me } = userQuery.data
  let isOwner = false
  let isTeam = false
  if (me.subscription !== null && me.subscription !== undefined) {
    const { user } = me.subscription
    isOwner = checkOwner(me.id, user?.id)
    isTeam = me.subscription?.plan.metadata.threshold !== undefined && me.subscription?.plan.metadata.threshold > 1
  }

  return (
    <>
      <DataCollectionInfo />
      <Title>
        à propos de vous
      </Title>
      <ProfileForm />
      { isOwner && isTeam && (
        <>
          <Title>
            votre pharmacie
          </Title>
          <PharmacyForm />
        </>
      )}
    </>
  )
}

const Title = styled.h3`
  margin: 2rem 0 1rem;
  font-family: 'brother-1816';
  font-size: 1.5rem;
  font-style: normal;
  font-weight: bold;
  color: ${colors.lightGreen};
`

export default Profile
